import { Box, Grid, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import StayInLoop from "../components/StayInLoop";
import RequestDemoBox from "../components/RequestDemoBox";

export default function RequestDemo() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <Box
        sx={{
          position: "relative",
          minHeight: { xs: "70vh", md: "70vh" },
          overflow: "hidden",
          padding: "60px 24px",
          margin: "auto",
          maxWidth: "1250px",
        }}
      >
        {/* Background Video */}
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            zIndex: -1,
            overflow: "hidden",
          }}
        >
          <video
            autoPlay
            loop
            muted
             playsInline
  preload="metadata"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          >
            <source src="/HomeBGVideo.webm" type="video/webm" />
            Your browser does not support the video tag.
          </video>
        </Box>

        {/* Content Overlay */}

        <Grid container spacing={{ xs: 4, sm: 6, md: 12 }}>
          <Grid
            item
            xs={12}
            md={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              width: "80%",
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontWeight: 700,
                fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
                background:
                  "linear-gradient(262.41deg, #1DA1F2 -8.32%, #6843EC 93.3%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                textAlign: "center",
                letterSpacing: isMobile ? "0px" : "-2.4px",
                display: "flex",
                justifyContent: "center",
                mt: {xs:2,md:4},
              }}
            >
              Let’s Connect and Collaborate!
            </Typography>

            <Box>
              <Typography
                sx={{
                  fontSize: { xs: "16px", sm: "18px" },
                  fontWeight: 400,
                  color: "#8C8CC2",
                  textAlign: "center",
                  mt: {xs:2,md:4},
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: {xs:4,md:8}
                }}
              >
                Have questions or need assistance? Reach out to us, and our team
                will be happy to help you find the perfect solution.
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <RequestDemoBox />
      </Box>
      <Box
        sx={{
          minHeight: "50vh",
          background: "linear-gradient(90deg, #0066CC 0%, #4B0082 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: theme.spacing(4),
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Contact Info Box */}
        <Grid container spacing={0} maxWidth="1250px" margin="auto">
          <Grid item xs={12} sm={6} md={6}>
            <Box sx={{ padding: { xs: 0, md: 4 } }}>
              <Typography
                variant="h3"
                component="h2"
                sx={{
                  fontWeight: 700,
                  color: "white",
                  fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
                  lineHeight: { xs: "2.5rem", md: "3.5rem" },
                  mb: 4,
                }}
              >
                We are always happy to assist you
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={6}>
            <Grid container>
              {/* Email Column */}
              <Grid item xs={12} sm={6} sx={{ mb: { xs: 3, sm: 0 } }}>
                <Box>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      color: "white",
                      fontSize: "20px",
                      pb: 1,
                      mb: 2,
                    }}
                  >
                    Email Address
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "white",
                      mb: 1,
                    }}
                  >
                    help@info.com
                  </Typography>

                  <Typography
                    variant="subtitle1"
                    sx={{
                      color: "white",
                      mt: 3,
                    }}
                  >
                    Assistance hours:
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "white",
                    }}
                  >
                    Monday - Friday 6 am
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "white",
                    }}
                  >
                    to 8 pm EST
                  </Typography>
                </Box>
              </Grid>

              {/* Phone Number Column */}
              <Grid item xs={12} sm={6}>
                <Box>
                  <Typography
                    sx={{
                      color: "white",
                      pb: 1,
                      mb: 2,
                      fontSize: "20px",
                    }}
                  >
                    Number
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "white",
                      mb: 1,
                    }}
                  >
                    (808) 998-34256
                  </Typography>

                  <Typography
                    variant="subtitle1"
                    sx={{
                      color: "white",
                      mt: 3,
                    }}
                  >
                    Assistance hours:
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "white",
                    }}
                  >
                    Monday - Friday 6 am
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "white",
                    }}
                  >
                    to 8 pm EST
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <StayInLoop />
    </>
  );
}
